import * as getTypes from '../get-types'
import * as actionTypes from '../action-types'
import * as mutationTypes from '../mutation-types'
import { DigitalRecipient } from '../classes/recipient-digital'
import { PhysicalRecipient } from '../classes/recipient-physical'

const state = {
  digitalRecipient: new DigitalRecipient(),
  physicalRecipient: new PhysicalRecipient()
}

const getters = {
  [getTypes.GET_RECIPIENT_DATA]: state => state.digitalRecipient,
  [getTypes.GET_PHYSICAL_RECIPIENT]: state => state.physicalRecipient,
  [getTypes.GET_DIGITAL_RECIPIENT]: state => state.digitalRecipient
}

const actions = {
  [actionTypes.SET_RECIPIENT_DATA] (context, recipientData) {
    context.commit(mutationTypes.SET_RECIPIENT_DATA, recipientData)
  },
  [actionTypes.UPDATE_DIGITAL_RECIPIENT_DATA] (context, recipientData) {
    context.commit(mutationTypes.UPDATE_DIGITAL_RECIPIENT_DATA, recipientData)
  },
  [actionTypes.UPDATE_PHYSICAL_RECIPIENT_DATA] (context, recipientData) {
    context.commit(mutationTypes.UPDATE_PHYSICAL_RECIPIENT_DATA, recipientData)
  }
}

const mutations = {
  [mutationTypes.SET_RECIPIENT_DATA] (
    state,
    { firstName, lastName, emailAddress } = {}
  ) {
    state.digitalRecipient = {
      firstName,
      lastName,
      emailAddress
    }
  },
  [mutationTypes.UPDATE_DIGITAL_RECIPIENT_DATA] (state, recipientUpdates = {}) {
    const { digitalRecipient } = state
    state.digitalRecipient = new DigitalRecipient({
      ...digitalRecipient,
      ...recipientUpdates
    })
  },
  [mutationTypes.UPDATE_PHYSICAL_RECIPIENT_DATA] (state, recipientUpdates = {}) {
    const { physicalRecipient } = state
    state.physicalRecipient = new PhysicalRecipient({
      ...physicalRecipient,
      ...recipientUpdates
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
